/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { EdrDeploymentTypeEnum } from '../model/edrDeploymentTypeEnum';
// @ts-ignore
import { EdrOrgWithApiKeys } from '../model/edrOrgWithApiKeys';
// @ts-ignore
import { EdrOrgsValidateResponse } from '../model/edrOrgsValidateResponse';
// @ts-ignore
import { ErrorResponse } from '../model/errorResponse';
// @ts-ignore
import { OnPremEdrOrgsListResponse } from '../model/onPremEdrOrgsListResponse';
// @ts-ignore
import { TaskV2 } from '../model/taskV2';
// @ts-ignore
import { TenantOnPremEdrOrgSpec } from '../model/tenantOnPremEdrOrgSpec';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class RansomwareRecoveryOnpremVcdrService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Create ONPREM API key for EDR organization (Tenant)
     * Create a new ONPREM API key for the specified Carbon Black EDR organization. Not supported for CrowdStrike. Returns an async task reference. Only supported for managed-mode organizations. 
     * @param orgId Organization identifier
     * @param edrVendor EDR vendor to use. cs - CrowdStrike and cb - Carbon Black.
     * @param edrOrgId EDR organization ID
     * @param deploymentType EDR deployment type for on-premises API key management. Must be ON_PREM.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createOnPremApiKeyTenant(orgId: string, edrVendor: 'cs' | 'cb', edrOrgId: string, deploymentType: EdrDeploymentTypeEnum, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TaskV2>;
    public createOnPremApiKeyTenant(orgId: string, edrVendor: 'cs' | 'cb', edrOrgId: string, deploymentType: EdrDeploymentTypeEnum, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TaskV2>>;
    public createOnPremApiKeyTenant(orgId: string, edrVendor: 'cs' | 'cb', edrOrgId: string, deploymentType: EdrDeploymentTypeEnum, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TaskV2>>;
    public createOnPremApiKeyTenant(orgId: string, edrVendor: 'cs' | 'cb', edrOrgId: string, deploymentType: EdrDeploymentTypeEnum, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (orgId === null || orgId === undefined) {
            throw new Error('Required parameter orgId was null or undefined when calling createOnPremApiKeyTenant.');
        }
        if (edrVendor === null || edrVendor === undefined) {
            throw new Error('Required parameter edrVendor was null or undefined when calling createOnPremApiKeyTenant.');
        }
        if (edrOrgId === null || edrOrgId === undefined) {
            throw new Error('Required parameter edrOrgId was null or undefined when calling createOnPremApiKeyTenant.');
        }
        if (deploymentType === null || deploymentType === undefined) {
            throw new Error('Required parameter deploymentType was null or undefined when calling createOnPremApiKeyTenant.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>deploymentType, 'deployment_type');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcdr/org/${this.configuration.encodeParam({name: "orgId", value: orgId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/rwr/${this.configuration.encodeParam({name: "edrVendor", value: edrVendor, in: "path", style: "simple", explode: false, dataType: "'cs' | 'cb'", dataFormat: undefined})}/edr-orgs/${this.configuration.encodeParam({name: "edrOrgId", value: edrOrgId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/api-keys`;
        return this.httpClient.request<TaskV2>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete ONPREM API key for EDR organization (Tenant)
     * Delete an ONPREM API key for the specified Carbon Black EDR organization. Not supported for CrowdStrike. Returns an async task reference. Only supported for managed-mode organizations. 
     * @param orgId Organization identifier
     * @param edrVendor EDR vendor to use. cs - CrowdStrike and cb - Carbon Black.
     * @param edrOrgId EDR organization ID
     * @param apiKeyId API key ID (format ONPREM:&lt;UUID&gt; for Carbon Black on-premises keys)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteOnPremApiKeyTenant(orgId: string, edrVendor: 'cs' | 'cb', edrOrgId: string, apiKeyId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TaskV2>;
    public deleteOnPremApiKeyTenant(orgId: string, edrVendor: 'cs' | 'cb', edrOrgId: string, apiKeyId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TaskV2>>;
    public deleteOnPremApiKeyTenant(orgId: string, edrVendor: 'cs' | 'cb', edrOrgId: string, apiKeyId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TaskV2>>;
    public deleteOnPremApiKeyTenant(orgId: string, edrVendor: 'cs' | 'cb', edrOrgId: string, apiKeyId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (orgId === null || orgId === undefined) {
            throw new Error('Required parameter orgId was null or undefined when calling deleteOnPremApiKeyTenant.');
        }
        if (edrVendor === null || edrVendor === undefined) {
            throw new Error('Required parameter edrVendor was null or undefined when calling deleteOnPremApiKeyTenant.');
        }
        if (edrOrgId === null || edrOrgId === undefined) {
            throw new Error('Required parameter edrOrgId was null or undefined when calling deleteOnPremApiKeyTenant.');
        }
        if (apiKeyId === null || apiKeyId === undefined) {
            throw new Error('Required parameter apiKeyId was null or undefined when calling deleteOnPremApiKeyTenant.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcdr/org/${this.configuration.encodeParam({name: "orgId", value: orgId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/rwr/${this.configuration.encodeParam({name: "edrVendor", value: edrVendor, in: "path", style: "simple", explode: false, dataType: "'cs' | 'cb'", dataFormat: undefined})}/edr-orgs/${this.configuration.encodeParam({name: "edrOrgId", value: edrOrgId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/api-keys/${this.configuration.encodeParam({name: "apiKeyId", value: apiKeyId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        return this.httpClient.request<TaskV2>('delete', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Deprovision EDR organization (Tenant)
     * Deprovision an EDR organization for the specified tenant. Deactivates all active ONPREM api-keys synchronously, then deprovisions the EDR org from the vendor cloud and deletes it from RMS. Returns a task reference in terminal state (DONE/FAILED). Only supported for managed-mode organizations. The EDR org must have no active cloud (non-ONPREM) deployments; deactivate them first if present. 
     * @param orgId Organization identifier
     * @param edrVendor EDR vendor to use. cs - CrowdStrike and cb - Carbon Black.
     * @param edrOrgId EDR organization ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deprovisionEdrOrgTenant(orgId: string, edrVendor: 'cs' | 'cb', edrOrgId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TaskV2>;
    public deprovisionEdrOrgTenant(orgId: string, edrVendor: 'cs' | 'cb', edrOrgId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TaskV2>>;
    public deprovisionEdrOrgTenant(orgId: string, edrVendor: 'cs' | 'cb', edrOrgId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TaskV2>>;
    public deprovisionEdrOrgTenant(orgId: string, edrVendor: 'cs' | 'cb', edrOrgId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (orgId === null || orgId === undefined) {
            throw new Error('Required parameter orgId was null or undefined when calling deprovisionEdrOrgTenant.');
        }
        if (edrVendor === null || edrVendor === undefined) {
            throw new Error('Required parameter edrVendor was null or undefined when calling deprovisionEdrOrgTenant.');
        }
        if (edrOrgId === null || edrOrgId === undefined) {
            throw new Error('Required parameter edrOrgId was null or undefined when calling deprovisionEdrOrgTenant.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcdr/org/${this.configuration.encodeParam({name: "orgId", value: orgId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/rwr/${this.configuration.encodeParam({name: "edrVendor", value: edrVendor, in: "path", style: "simple", explode: false, dataType: "'cs' | 'cb'", dataFormat: undefined})}/edr-orgs/${this.configuration.encodeParam({name: "edrOrgId", value: edrOrgId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        return this.httpClient.request<TaskV2>('delete', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * List assigned EDR organizations (Tenant)
     * List all EDR organizations assigned to the tenant for the given vendor
     * @param orgId Organization identifier
     * @param edrVendor EDR vendor to use. cs - CrowdStrike and cb - Carbon Black.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getEdrOrgsTenant(orgId: string, edrVendor: 'cs' | 'cb', observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<OnPremEdrOrgsListResponse>;
    public getEdrOrgsTenant(orgId: string, edrVendor: 'cs' | 'cb', observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<OnPremEdrOrgsListResponse>>;
    public getEdrOrgsTenant(orgId: string, edrVendor: 'cs' | 'cb', observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<OnPremEdrOrgsListResponse>>;
    public getEdrOrgsTenant(orgId: string, edrVendor: 'cs' | 'cb', observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (orgId === null || orgId === undefined) {
            throw new Error('Required parameter orgId was null or undefined when calling getEdrOrgsTenant.');
        }
        if (edrVendor === null || edrVendor === undefined) {
            throw new Error('Required parameter edrVendor was null or undefined when calling getEdrOrgsTenant.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcdr/org/${this.configuration.encodeParam({name: "orgId", value: orgId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/rwr/${this.configuration.encodeParam({name: "edrVendor", value: edrVendor, in: "path", style: "simple", explode: false, dataType: "'cs' | 'cb'", dataFormat: undefined})}/edr-orgs`;
        return this.httpClient.request<OnPremEdrOrgsListResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * List EDR organization API keys (Tenant)
     * List all API keys for the specified EDR organization. For Carbon Black, returns only ONPREM api keys. For CrowdStrike, returns the single GLOBAL key. Only supported for managed-mode organizations. 
     * @param orgId Organization identifier
     * @param edrVendor EDR vendor to use. cs - CrowdStrike and cb - Carbon Black.
     * @param edrOrgId EDR organization ID
     * @param deploymentType EDR deployment type for on-premises API key management. Must be ON_PREM.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listApiKeysTenant(orgId: string, edrVendor: 'cs' | 'cb', edrOrgId: string, deploymentType: EdrDeploymentTypeEnum, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<EdrOrgWithApiKeys>;
    public listApiKeysTenant(orgId: string, edrVendor: 'cs' | 'cb', edrOrgId: string, deploymentType: EdrDeploymentTypeEnum, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<EdrOrgWithApiKeys>>;
    public listApiKeysTenant(orgId: string, edrVendor: 'cs' | 'cb', edrOrgId: string, deploymentType: EdrDeploymentTypeEnum, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<EdrOrgWithApiKeys>>;
    public listApiKeysTenant(orgId: string, edrVendor: 'cs' | 'cb', edrOrgId: string, deploymentType: EdrDeploymentTypeEnum, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (orgId === null || orgId === undefined) {
            throw new Error('Required parameter orgId was null or undefined when calling listApiKeysTenant.');
        }
        if (edrVendor === null || edrVendor === undefined) {
            throw new Error('Required parameter edrVendor was null or undefined when calling listApiKeysTenant.');
        }
        if (edrOrgId === null || edrOrgId === undefined) {
            throw new Error('Required parameter edrOrgId was null or undefined when calling listApiKeysTenant.');
        }
        if (deploymentType === null || deploymentType === undefined) {
            throw new Error('Required parameter deploymentType was null or undefined when calling listApiKeysTenant.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>deploymentType, 'deployment_type');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcdr/org/${this.configuration.encodeParam({name: "orgId", value: orgId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/rwr/${this.configuration.encodeParam({name: "edrVendor", value: edrVendor, in: "path", style: "simple", explode: false, dataType: "'cs' | 'cb'", dataFormat: undefined})}/edr-orgs/${this.configuration.encodeParam({name: "edrOrgId", value: edrOrgId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/api-keys`;
        return this.httpClient.request<EdrOrgWithApiKeys>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * List EDR regions (Tenant)
     * List available VMware-managed EDR regions for the specified vendor.
     * @param orgId Organization identifier
     * @param edrVendor EDR vendor to use. cs - CrowdStrike and cb - Carbon Black.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listEdrRegionsTenant(orgId: string, edrVendor: 'cs' | 'cb', observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<EdrOrgsValidateResponse>;
    public listEdrRegionsTenant(orgId: string, edrVendor: 'cs' | 'cb', observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<EdrOrgsValidateResponse>>;
    public listEdrRegionsTenant(orgId: string, edrVendor: 'cs' | 'cb', observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<EdrOrgsValidateResponse>>;
    public listEdrRegionsTenant(orgId: string, edrVendor: 'cs' | 'cb', observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (orgId === null || orgId === undefined) {
            throw new Error('Required parameter orgId was null or undefined when calling listEdrRegionsTenant.');
        }
        if (edrVendor === null || edrVendor === undefined) {
            throw new Error('Required parameter edrVendor was null or undefined when calling listEdrRegionsTenant.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcdr/org/${this.configuration.encodeParam({name: "orgId", value: orgId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/rwr/${this.configuration.encodeParam({name: "edrVendor", value: edrVendor, in: "path", style: "simple", explode: false, dataType: "'cs' | 'cb'", dataFormat: undefined})}/edr-regions`;
        return this.httpClient.request<EdrOrgsValidateResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Provision EDR organization (Tenant)
     * Provision a new EDR organization for on-premises deployment. Returns an exception if an EDR org is already provisioned for the given organization and region.
     * @param orgId Organization identifier
     * @param edrVendor EDR vendor to use. cs - CrowdStrike and cb - Carbon Black.
     * @param tenantOnPremEdrOrgSpec EDR organization specification
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public provisionEdrOrgTenant(orgId: string, edrVendor: 'cs' | 'cb', tenantOnPremEdrOrgSpec: TenantOnPremEdrOrgSpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TaskV2>;
    public provisionEdrOrgTenant(orgId: string, edrVendor: 'cs' | 'cb', tenantOnPremEdrOrgSpec: TenantOnPremEdrOrgSpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TaskV2>>;
    public provisionEdrOrgTenant(orgId: string, edrVendor: 'cs' | 'cb', tenantOnPremEdrOrgSpec: TenantOnPremEdrOrgSpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TaskV2>>;
    public provisionEdrOrgTenant(orgId: string, edrVendor: 'cs' | 'cb', tenantOnPremEdrOrgSpec: TenantOnPremEdrOrgSpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (orgId === null || orgId === undefined) {
            throw new Error('Required parameter orgId was null or undefined when calling provisionEdrOrgTenant.');
        }
        if (edrVendor === null || edrVendor === undefined) {
            throw new Error('Required parameter edrVendor was null or undefined when calling provisionEdrOrgTenant.');
        }
        if (tenantOnPremEdrOrgSpec === null || tenantOnPremEdrOrgSpec === undefined) {
            throw new Error('Required parameter tenantOnPremEdrOrgSpec was null or undefined when calling provisionEdrOrgTenant.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcdr/org/${this.configuration.encodeParam({name: "orgId", value: orgId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/rwr/${this.configuration.encodeParam({name: "edrVendor", value: edrVendor, in: "path", style: "simple", explode: false, dataType: "'cs' | 'cb'", dataFormat: undefined})}/edr-orgs`;
        return this.httpClient.request<TaskV2>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: tenantOnPremEdrOrgSpec,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
